export default function getUserFirstName(name: string) {
  return name.split(' ')[0] || 'User'
}
